import { companyDomainApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const COMPANY_DOMAINS_ACTION_TYPE = createNamedActions('companyDomains', {
  GET_DOMAINS: 'GET_DOMAINS',
  ADD_DOMAINS: 'ADD_DOMAINS',
  REMOVE_DOMAINS: 'REMOVE_DOMAINS',
});

export const getDomainsAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await companyDomainApi.getCompanyDomains(params);

  return dispatch({
    type: COMPANY_DOMAINS_ACTION_TYPE.GET_DOMAINS,
    payload: { [params.companyId]: data },
  });
});

export const createDomainAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await companyDomainApi.createCompanyDomain(params);

  return dispatch({
    type: COMPANY_DOMAINS_ACTION_TYPE.ADD_DOMAINS,
    payload: { companyId: params.companyId, ...data },
  });
});

export const deleteDomainAction = catchAsyncActionError(params => async dispatch => {
  await companyDomainApi.deleteCompanyDomain(params);

  return dispatch({
    type: COMPANY_DOMAINS_ACTION_TYPE.REMOVE_DOMAINS,
    payload: params,
  });
});
